import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import Paper from "@material-ui/core/Paper";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import AuthWrapperStyle from "../wrappers/AuthWrapper";
import CustomTextField from "../components/fields/CustomTextField";
import CircularProgress from '@material-ui/core/CircularProgress';
import NotificationSnackBar from '../utils/NotificationSnackBar';
import Grid from '@material-ui/core/Grid';
import '../css/main.css';
import { loginAct } from "../actions";

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    loadingHeight: {
        height: "100%",
        position: "fixed",
        top: "0",
        right: "0"
    },
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: 350
  },
  button: {
    width: 300,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 10
  },
  alreadySignIn: {
    marginTop: 10,
    marginBottom: 10,
    marginLeft: "auto",
    marginRight: "auto"
  },
  textField:{

  },
  success: {
    marginTop: 10,
    marginBottom: 10,
    marginLeft: "auto",
    marginRight: "auto",
    color: "green"
  }
});

const required_fields = [
  { name: "username", label: "username" },
  { name: "password", label: "password" }
];

class SignIn extends Component {
    state = {
        loading: false, 
        signIn:{},
        username:'',
        password:'',
    };
    _handleSubmit = values => {
        this.updateSnackbarStatusFalse();
        this.setState({ loading: true });
        this.props.loginAct({username: this.state.username, password: this.state.password}, this.props.history);
    };

  componentWillMount() { 
    if (localStorage.getItem("sessionKey")) {
      this.props.history.push("/dashboard");
      }
   }

    componentWillReceiveProps(signIn) {
      console.log(signIn)
        if (this.props.signIn != signIn) {
            this.setState({ loading: signIn.loading });
            this.updateSnackbarStatus(signIn);
        } else {
            this.updateSnackbarStatusFalse();
        }
    }

    handleChange=(name)=>event =>{ 
      console.log(name)
      this.setState({[name]: event.target.value, });
  }

    updateSnackbarStatus = (snackbarObject) => {
        this.setState({
            isSnackbarError: snackbarObject.isSnackbarError,
            isSwitchSnackbarOn: snackbarObject.isSwitchSnackbarOn,
            snackbarErrorMessage: snackbarObject.ErrorMessage
        })
    }

    updateSnackbarStatusFalse = () => {
        if (this.state.isSwitchSnackbarOn) {
            this.setState({ isSwitchSnackbarOn: false })
        }
    }

  render() {
    const { classes, signIn } = this.props;
    return (
      <AuthWrapperStyle>
        <Paper>
          <form
            className={classes.container}
            onSubmit={this.props.handleSubmit(this._handleSubmit)}
          >
            <CustomTextField
              fullWidth={true}
              name="username"
              type="text"
              id="username"
              label="Username" 
              InputValue={this.state.username}
              onChange={this.handleChange('username')}
            />
            <CustomTextField
              fullWidth={true}
              name="password"
              type="password"
              id="password"
              label="Password" 
              InputValue={this.state.password}
              onChange={this.handleChange('password')}
            />
            <Button
              className={classes.button}
              type="submit"
              variant="contained"
              color="primary"
            >
              Sign In
            </Button>
            {signIn.success ? (
              <Typography className={classes.success} component="p">
                {signIn.ErrorMessage}
              </Typography>
            ) : null}

            <Typography className={classes.alreadySignIn} component="p">
              Or request at  <a href='mailto:request@geotech.solutions'>request@geotech.solutions</a>
              <br />
            </Typography>

            {signIn.error ? (
              <Typography className={classes.alreadySignIn} component="p">
                {signIn.ErrorMessage}
              </Typography>
            ) : null}
          </form>
            </Paper>
            {this.state.loading ? (
                <Grid container className={classes.root}>
                    <div className="loadingSpinner"></div>
                        <Grid item xs={12}>
                            <Grid container className={classes.loadingHeight} justify='center' alignItems='center'>
                                <CircularProgress color="primary" size={70} thickness={7} />
                            </Grid>
                    </Grid>
                </Grid>
                ) : null
            }
            <NotificationSnackBar
                isSwitchSnackbarOn={this.state.isSwitchSnackbarOn}
                isSnackbarError={this.state.isSnackbarError}
                snackbarErrorMessage={this.state.snackbarErrorMessage}
            />
      </AuthWrapperStyle>
    );
  }
}

function validate(values) {
  const errors = {};

  required_fields.forEach(({ name, label }) => {
    if (!values[name]) {
      errors[name] = `You must provide ${label}`;
    }
  });

  return errors;
}

let SignInWithStyles1 =  withStyles(styles)(SignIn);

let SignInWithStyles2 = reduxForm({
  validate,
  form: "signInForm"
})(SignInWithStyles1);

function mapStateToProps({ signIn }) {
  console.log(signIn)
  return {
    signIn,
    
  };
}

export default connect(
  mapStateToProps,
  { loginAct }
)(SignInWithStyles2);



// WEBPACK FOOTER //
// ./src/components/SignIn.js